import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentformahabaleshwar() {



const cardData =
{
  keyword: 'Bus on Rent for Mahabaleshwar Picnic',
  heading: 'Sanavi Travels: Bus on Rent for Mahabaleshwar Picnic',
  headingDescription: 'Sanavi Travels offers reliable, comfortable, and well-organized Bus on Rent for Mahabaleshwar Picnic, specially designed for families, corporate groups, students, friends, and large tour groups planning a refreshing hill-station getaway. Mahabaleshwar is one of Maharashtra’s most popular picnic and weekend destinations, known for its cool climate, scenic viewpoints, strawberry farms, waterfalls, and lush greenery, making safe and comfortable group transportation essential. Our bus rental service for Mahabaleshwar picnic is ideal for one-day trips, overnight stays, weekend tours, school excursions, corporate outings, and family vacations. We provide a wide range of AC and Non-AC buses, mini buses, and luxury coaches with spacious seating, ample legroom, and sufficient luggage space to handle hill travel comfortably. All buses are regularly maintained, safety-checked, and driven by experienced drivers who are familiar with ghat roads, sharp turns, weather conditions, and tourist routes of Mahabaleshwar. With transparent pricing, flexible pickup points, customized itineraries, and professional trip coordination, Sanavi Travels ensures a smooth, safe, and memorable Mahabaleshwar picnic journey from start to finish.',

  top: 'Top Picnic Experiences in Mahabaleshwar with Sanavi Travels',

  "topPlaces": [
    {
      "title": "Family Picnic Trips to Mahabaleshwar",
      "description": "Mahabaleshwar is a favorite family picnic destination due to its pleasant climate, scenic viewpoints, gardens, and calm environment. Bus on rent for family picnic to Mahabaleshwar ensures safe, comfortable, and stress-free travel for all age groups, allowing families to enjoy sightseeing without worrying about driving on hilly roads."
    },
    {
      "title": "Corporate Picnic & Team Outings",
      "description": "Corporate groups frequently choose Mahabaleshwar for team outings and employee engagement trips. Renting a bus for corporate picnic provides organized group travel, punctual schedules, and a relaxed journey that helps teams bond while enjoying nature."
    },
    {
      "title": "Student Picnic & Educational Tours",
      "description": "Schools and colleges often plan student picnics and educational tours to Mahabaleshwar. Bus rental services ensure disciplined travel, safety compliance, experienced drivers, and smooth handling of large student groups throughout the journey."
    },
    {
      "title": "Group Tours & Friends Trips",
      "description": "Friend groups and social circles prefer Mahabaleshwar for weekend getaways. Hiring a bus allows everyone to travel together, enjoy scenic routes, and focus on fun without navigation or parking stress."
    },
    {
      "title": "Viewpoints & Scenic Spots",
      "description": "Mahabaleshwar is famous for viewpoints like Arthur’s Seat, Wilson Point, Kate’s Point, and Elephant’s Head Point. Bus travel makes it easier for groups to cover multiple viewpoints comfortably."
    },
    {
      "title": "Strawberry Farms & Local Markets",
      "description": "Seasonal strawberry farms and local markets are major attractions. Bus rentals provide flexible stoppages and sufficient luggage space for shopping and local produce."
    },
    {
      "title": "Waterfalls & Nature Trails",
      "description": "During monsoon and winter, Mahabaleshwar offers beautiful waterfalls and lush nature trails. Comfortable bus travel ensures safe access to these areas even during slippery conditions."
    },
    {
      "title": "One-Day and Overnight Picnics",
      "description": "Whether it is a one-day picnic or an overnight stay, bus on rent for Mahabaleshwar picnic supports flexible itineraries and group-friendly travel planning."
    },
    {
      "title": "Safe Ghat Road Travel",
      "description": "Mahabaleshwar ghat roads require experienced driving skills. Professional bus drivers ensure safety, controlled speed, and confidence on steep and winding roads."
    },
    {
      "title": "Stress-Free Group Travel Experience",
      "description": "Bus rental eliminates the need for multiple vehicles, coordination issues, and navigation stress, offering a smooth and enjoyable picnic experience."
    }
  ],

  "services": [
    {
      "name": "Bus on Rent for Mahabaleshwar Picnic",
      "description": "Sanavi Travels provides complete bus rental solutions for Mahabaleshwar picnic trips, covering family outings, corporate picnics, student tours, and group travel. Our service includes well-maintained buses, experienced drivers, flexible pickup locations, route planning, and reliable scheduling. The focus is on safety, comfort, and enjoyment throughout the journey, ensuring a memorable picnic experience."
    },
    {
      "name": "AC Bus for Mahabaleshwar",
      "description": "AC buses for Mahabaleshwar picnic offer cool and comfortable travel, especially suitable for long journeys, summer trips, and corporate outings, ensuring passengers remain relaxed throughout the ride."
    },
    {
      "name": "Non AC Bus Rental Mahabaleshwar",
      "description": "Non AC bus rental is a budget-friendly option for groups looking for economical travel without compromising safety and reliability."
    },
    {
      "name": "Luxury Bus Hire Mahabaleshwar",
      "description": "Luxury bus hire for Mahabaleshwar picnic provides premium interiors, spacious seating, and enhanced comfort, ideal for corporate teams and premium group travel."
    },
    {
      "name": "Mini Bus on Rent Mahabaleshwar",
      "description": "Mini buses are perfect for small groups, families, and friends planning a cozy and flexible picnic trip to Mahabaleshwar."
    },
    {
      "name": "32 Seater Bus for Mahabaleshwar",
      "description": "32 seater buses are ideal for medium-sized groups, schools, and corporate outings, offering balanced seating capacity and comfort."
    },
    {
      "name": "35 Seater Bus Hire Mahabaleshwar",
      "description": "35 seater buses are suitable for large picnic groups, ensuring everyone travels together safely and comfortably."
    },
    {
      "name": "Bus for Family Picnic Mahabaleshwar",
      "description": "Family picnic bus services focus on comfort, safety, and smooth travel for children, adults, and senior citizens."
    },
    {
      "name": "Bus for Corporate Picnic Mahabaleshwar",
      "description": "Corporate picnic bus services ensure punctual travel, professional drivers, and organized group transportation for team outings."
    },
    {
      "name": "Affordable Bus Rental Mahabaleshwar",
      "description": "Affordable bus rental options help groups manage travel budgets while still enjoying reliable and comfortable transportation."
    },
    {
      "name": "Best Bus Service Mahabaleshwar",
      "description": "Sanavi Travels is trusted as one of the best bus services for Mahabaleshwar picnic trips due to safety, punctuality, and service quality."
    },
    {
      "name": "Bus Hire with Driver Mahabaleshwar",
      "description": "All buses come with experienced drivers who understand hill routes, weather conditions, and tourist traffic patterns."
    },
    {
      "name": "Bus for Group Tour Mahabaleshwar",
      "description": "Group tour buses allow coordinated travel for friends, associations, and organizations planning Mahabaleshwar trips."
    },
    {
      "name": "Bus for Student Picnic Mahabaleshwar",
      "description": "Student picnic bus services emphasize safety, discipline, and smooth coordination for school and college trips."
    },
    {
      "name": "Outstation Bus Rental Mahabaleshwar",
      "description": "Outstation bus rentals ensure comfortable long-distance travel with planned breaks, safe driving, and reliable scheduling."
    }
  ],

  "tableData": [
    ["Bus for Mahabaleshwar Picnic", "Family Picnic Bus"],
    ["Corporate Picnic Bus", "Student Picnic Bus"],
    ["AC Bus", "Non AC Bus"],
    ["32 Seater Bus", "35 Seater Bus"],
    ["Luxury Bus", "Mini Bus"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Experienced Hill Route Drivers",
      "WhyChoosedescription": "Drivers are trained for ghat roads and hill driving safety."
    },
    {
      "WhyChooseheading": "Comfortable & Clean Buses",
      "WhyChoosedescription": "Well-maintained buses ensure relaxed picnic travel."
    },
    {
      "WhyChooseheading": "Group-Friendly Travel Planning",
      "WhyChoosedescription": "Customized itineraries and pickup points available."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "Transparent and budget-friendly bus rental packages."
    },
    {
      "WhyChooseheading": "Safe & Reliable Service",
      "WhyChoosedescription": "Safety checks and disciplined operations on every trip."
    },
    {
      "WhyChooseheading": "Flexible Picnic Schedules",
      "WhyChoosedescription": "Supports one-day and overnight Mahabaleshwar trips."
    },
    {
      "WhyChooseheading": "Large Fleet Options",
      "WhyChoosedescription": "Mini buses to luxury coaches available."
    },
    {
      "WhyChooseheading": "Trusted Travel Partner",
      "WhyChoosedescription": "Sanavi Travels is trusted for Mahabaleshwar picnic travel."
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide buses for Mahabaleshwar picnic?',
    answer: 'Yes, Sanavi Travels provides buses for family, corporate, and student picnics to Mahabaleshwar.'
  },
  {
    question: 'Are AC buses available for Mahabaleshwar?',
    answer: 'Yes, AC buses are available for comfortable hill travel.'
  },
  {
    question: 'Can we book a bus for one-day picnic?',
    answer: 'Yes, one-day and overnight picnic bus rentals are available.'
  },
  {
    question: 'Do buses include a driver?',
    answer: 'Yes, all bus rentals include experienced drivers.'
  },
  {
    question: 'Is Mahabaleshwar ghat driving safe?',
    answer: 'Yes, our drivers are trained and experienced in ghat road driving.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshmukh',
    feedback: 'Our Mahabaleshwar picnic bus was very comfortable and well-managed. Excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Kulkarni',
    feedback: 'Best bus service for Mahabaleshwar picnic. Safe driving and great coordination.',
    rating: 5
  }
];


































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent for Mahabaleshwar Picnic - Sanavi Travels",
  "description": "Sanavi Travels offers buses on rent for Mahabaleshwar picnic trips, including family picnics, corporate outings, group tours, and student trips. AC and Non-AC buses, mini buses, 32-seater and 35-seater buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent for Mahabaleshwar Picnic | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses on rent for Mahabaleshwar picnic with Sanavi Travels. AC & Non-AC mini buses, 32-seater and 35-seater buses for family picnics, corporate outings, group tours, and student trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/265.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentformahabaleshwar;